import { render, staticRenderFns } from "./PreDefinedNote.vue?vue&type=template&id=5448d12b&scoped=true&"
import script from "./PreDefinedNote.vue?vue&type=script&lang=js&"
export * from "./PreDefinedNote.vue?vue&type=script&lang=js&"
import style0 from "./PreDefinedNote.vue?vue&type=style&index=0&id=5448d12b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5448d12b",
  null
  
)

export default component.exports